// extracted by mini-css-extract-plugin
export default {"TitleDialogContent":"ModalGlobal_TitleDialogContent__CFWHw","TitleDialogTexto":"ModalGlobal_TitleDialogTexto__jSDwX"};